import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Col,
  Row,
} from "antd";
import { RollbackOutlined
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { useHistory } from 'react-router-dom';

import { odata } from "../Filters/Helper";
import moment from "moment";

function CreditReportDetail(props) {
  const history = useHistory();
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: ``
  });
  const [order, setOrder] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentAmount, setCurrentAmount] = useState(0);

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  const getTableData = () => {

    const [accountId, startDate, endDate] = props.match.params.filter.split("&");

    setStartDate(startDate);
    setEndDate(endDate);

    setTableData({
      ...tableData,
      loading: true,
    });

    let query = '';
    const { skip, take, filter } = tableDataQueryOptions;

    const conditions = [];

    if (filter) {
      conditions.push(filter);
    }

    conditions.push(`date(date) ge date(${startDate}) and date(date) lt date(${endDate})`);
    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.get(
      `/CreditAccountDetail/${accountId}?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });

    RequestHandler.get(
      `/TenantAccount/GetById/${accountId}`
    ).then((response) => {
      if(response) {
        setCurrentAmount(response.balanceString);
      }

    });
  };


  const paging = (p, _, sorter) => {

    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };


  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      render: (text) => {
        return (
          <div style={{ width: 100 }}>
            {" "}
            <img src={text}></img>
          </div>
        );
      },
    },
    {
      title: "Hesap No/Iban",
      dataIndex: "accountNumber",
    },
    {
      title: "Tarih",
      dataIndex: "date",
      render: (data) => {
        return moment(data).format("DD.MM.YYYY");
      }
    },
    {
      title: "Bakiye",
      dataIndex: "amount"
    }
  ];

  return (
    <>
      <Row style={{ marginBottom: 9 }}>

        <Col flex={1}><a onClick={() => history.push("/credit-report", { startDate: startDate, endDate: endDate })} style={{ color: 'black', marginLeft: "4%" }}> <RollbackOutlined /> GERİ DÖN</a></Col>
        <Col flex={4}></Col>
      </Row>

      <Row>
        <Col span={24} style={{ textAlign: "end", fontSize: 19 }}>
          Güncel Bakiye : {currentAmount}
        </Col>
      </Row>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey="id"
            filterable={true}
            size="small"
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
          />
        </Col>
      </Row>
    </>
  );

}

export default CreditReportDetail;
